import { Dayjs } from 'dayjs';

export const dateToFilterString = (date: Dayjs) => {
  return date.format('YYYY-MM-DD');
};
